export class SmallMaterial {
    id: number;
    name: string;
}

